<template>
  <div class="file_info">
    <div class="">
      <p class="my-0 mt-3 text-center">
        <template v-if="data.is_dir">
          <template v-if="data.group == 'PERSONAL'">
            <img src="@/assets/icons/folder/png/Personal.png" width="180px" height="auto"/>
          </template>
          <template v-if="data.group == 'PUBLIC'">
            <img src="@/assets/icons/folder/png/Public.png" width="180px" height="auto"/>
          </template>
          <template v-if="data.group == 'PROJECT'">
            <img src="@/assets/icons/folder/png/Project.png" width="180px" height="auto"/>
          </template>
          <template v-if="data.group == 'GROUP'">
            <img src="@/assets/icons/folder/png/Group.png" width="180px" height="auto"/>
          </template>
        </template>
        <template v-else>
          <span v-if="!data.is_dir && word(data.extname)">
            <img src="@/assets/icons/icon/Doc.svg" width="60px" />
            <!--<img src="@/assets/word.svg" width="80px" /> -->
          </span>
          <span v-if="!data.is_dir && data.extname == '.pdf'">
            <img src="@/assets/icons/icon/PDF.svg" width="60px" />
            <!--<img src='@/assets/icons8-pdf-100.png' width="80px" />-->
          </span>
          <span>
            <img src="@/assets/icons/icon/Mp3.svg" width="60px" v-if="!data.is_dir && data.type == 'audio'">
          </span>
          <span v-if="!data.is_dir && data.type == 'video'">
            <img src='@/assets/play-video.jpg' />
          </span>
          <span v-if="!data.is_dir && code(data.extname)" class="fa fa-file-code"></span>
          <span v-if="!data.is_dir && data.extname == '.pub'"><img src="../assets/pub.png" /></span>
          <span  v-if="!data.is_dir && data.extname == '.zip' || !data.is_dir && data.extname == '.gz' || !data.is_dir && data.extname == '.tar'">
            <img src="@/assets/icons/icon/Rar.svg" width="60px" />
          </span>
          <span v-if="!data.is_dir && data.extname == '.ppt' || data.extname == '.pptx'">
            <img src="@/assets/icons/icon/PPT.svg" width="60px" />
          </span>
          <span v-if="!data.is_dir && excel(data.extname)">
            <img src="@/assets/icons/icon/XLS.svg" width="60px" height="auto" />
          </span>
          <!-- <span v-if="!data.dir.is_dir && data.dir.type == 'image'" @click="browse(data.index, data.dir)">
            <img :src=data.dir.thumbnail />
          </span> -->
          <span v-if="(!data.is_dir && data.extname == '.txt') || (!data.is_dir && data.extname == '')">
            <img src="@/assets/icons/icon/TXT.svg" width="60px" />
          </span>
          <span v-if="data.extname !== '.zip' && data.extname !== '.tar.gz' && data.extname !== '.ppt' && data.extname !== '.pptx' && !word(data.extname) && data.extname !== '.pdf' && data.type !== 'video' && data.type !== 'audio' && data.type !== 'image' && !data.is_dir && data.extname !== '.txt' && data.extname !== '' && !excel(data.extname) && !code(data.extname)">
            <img src="@/assets/icons/icon/Unkown File.svg"  width="60px" />
          </span>
          <span class="image" v-if="isImage(data.extname)">
            <img src="@/assets/icons/icon/image.svg"  width="100%" />
          </span>
        </template>
      </p>
      <p class="my-3"><strong>{{ str_text(data.is_dir, data.dir, data.extname) }}</strong></p>
      <p style="font-size: 13px">{{ type(data.is_dir, data.extname) }} - {{ $sizeFormat(data.size) }}</p>
    </div>
    <template
      v-if="
        data.db != 'sharedwithme' &&
        data.db != 'sharedfiles' &&
        data.db != 'group'
      "
    >
      <div class="file-data">
        <div class="row d-flex justify-content-between">
          <span>Created By</span>
          <span><strong>{{ data.createdby }}</strong></span>
        </div>
        <div class="row d-flex justify-content-between">
          <span>Date Created</span>
          <span><strong>{{ format_date(data.createdAt) }}</strong></span>
        </div>
        <div class="row d-flex justify-content-between">
          <span>Date Modified</span>
          <span><strong>{{ format_date(data.updatedAt) }}</strong></span>
        </div>
      </div>
    </template>
    <template v-if="data.db == 'group' && !data.is_group_parent">
      <div class="file-data">
        <div class="row d-flex justify-content-between">
          <span>Created By</span>
          <span>{{ data.createdby }}</span>
        </div>
        <div class="row d-flex justify-content-between">
          <span>Date Created</span>
          <span>{{ format_date(data.createdAt) }}</span>
        </div>
        <div class="row d-flex justify-content-between">
          <span>Date Modified</span>
          <span>{{ format_date(data.updatedAt) }}</span>
        </div>
      </div>
    </template>
    <template v-if="data.db == 'sharedwithme'">
      <div class="file-data">
        <div class="row d-flex justify-content-between">
          <span>Shared By</span>
          <span>{{ data.createdby }}</span>
        </div>
        <div class="row d-flex justify-content-between">
          <span>Date Shared</span>
          <span>{{ format_date(data.date_shared) }}</span>
        </div>
      </div>
    </template>
    <template v-if="data.db == 'sharedfiles'">
      <div class="file-data">
        <div class="row d-flex justify-content-between">
          <span>Shared With</span>
          <span>{{ data.sharedwith }}</span>
        </div>
        <div class="row d-flex justify-content-between">
          <span>Date Shared</span>
          <span>{{ format_date(data.date_shared) }}</span>
        </div>
      </div>
    </template>
    <template v-if="data.db == 'group' && data.is_group_parent == true">
      <div class="file-data">
        <div class="row d-flex justify-content-between">
          <span>Created By</span>
          <span>{{ data.createdby }}</span>
        </div>
        <div class="row d-flex justify-content-between">
          <span>Date Created</span>
          <span>{{ format_date(data.date_shared) }}</span>
        </div>
        <div class="row d-flex justify-content-between" v-if="data.collaboratorsDetails">
          <span>Collaborators</span>
          <div class="file-collaborators-container">
            <div class="file-collaborators-content">
              <template
                v-for="(collaborator, index) in data.collaboratorsDetails
                  .user_id"
              >
                <img
                  :key="index"
                  v-if="collaborator.photo && index < 2"
                  class="single-collaborator"
                  :src="getPhoto(collaborator.photo)"
                  :title="getUserName(collaborator.name)"
                />
                <div
                  :key="index"
                  v-else-if="index <= 2"
                  :title="getUserName(collaborator.name)"
                  class="single-collaborator"
                >
                  {{ getInitials(collaborator.name) }}
                </div>
              </template>
            </div>
            <span
              v-if="data.collaboratorsDetails.user_id.length > 3"
              class="single-collaborator-user"
              >&amp; {{ data.collaboratorsDetails.user_id.length - 3 }} other{{
                data.collaboratorsDetails.user_id.length - 3 >= 2 ? "s" : null
              }}</span
            >
            <div class="assigned-to-others-layout">
              <template
                v-for="(collaborator, index) in data.collaboratorsDetails
                  .user_id"
              >
                <div :key="index" class="assigned-to-div">
                  <img
                    v-if="collaborator.photo"
                    class="assigned-to-img"
                    :title="getUserName(collaborator.name)"
                    :src="getPhoto(collaborator.photo)"
                  />
                  <span
                    v-else
                    :title="getUserName(collaborator.name)"
                    class="single-user-initials"
                  >
                    {{ getInitials(collaborator.name) }}
                  </span>
                  <span class="assigned-to-span">{{getUserName(collaborator.name)}}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<style scoped>
.file-data .row {
  font-size: 13px !important;
}

.file-data .row span {
  width: auto !important;
  font-size: 13px !important;
}

.file-data .row span:first-child, .file-data .row span:last-child {
  width: auto !important;
  font-size: 13px !important;
}

.file-data {
  border-bottom: 1px solid #A7B9CB;
  border-top: 1px solid #A7B9CB;
  padding: 1em 0;
}
.custom-tooltip-container {
    position: relative;
    display: inline-block;
  }
  .custom-tooltip-container:hover .custom-tooltiptext {
    visibility: visible;
    opacity: 1;
    padding: 5px 10px;
  }
  .custom-tooltiptext {
    visibility: hidden;
    background-color: #596a73;
    color: #fff;
    text-align: center;
    border-radius: 3px;
    padding: 2px 5px;
    position: absolute;
    z-index: 1;
    top: 25px;
    opacity: 0;
    -webkit-transition: opacity 0.5s, padding 0.3s;
    transition: opacity 0.5s, padding 0.3s;
    font-size: 12px;
    display: inline-block;
    width: 145px;
  }
</style>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import ext from '../components/File-Extension.vue'
export default {
  props: {
    data: Object
  },
  computed: {
    ...mapState(['backendUrl'])
  },
  methods: {
    isImage(file) {
      try {
        let ext = file.extname ? file.extname : " ";
        if (ext) {
          ext = ext.split(".");
          ext = ext[ext.length - 1];
        }
        return (
          ext.toLowerCase() === "jpg" ||
          ext.toLowerCase() === "png" ||
          ext.toLowerCase() === "PNG" ||
          ext.toLowerCase() === "jpeg" ||
          ext.toLowerCase() === "JPG" ||
          ext.toLowerCase() === "JPEG" ||
          ext.toLowerCase() === "gif" ||
          ext.toLowerCase() === "GIF"
        );
      } catch (err) {
        return false;
      }
    },
    getFileIcon(file) {
      let name = file.split(".");
      let ext = name[name.length - 1];

      if (ext.toLowerCase() === "docx" || ext.toLowerCase() === "doc") {
        return ["fa fa-file-word", true];
      }

      if (ext.toLowerCase() === "xlsx" || ext.toLowerCase() === "xls") {
        return ["fa fa-file-excel", true];
      }

      if (ext.toLowerCase() === "pptx" || ext.toLowerCase() === "ppt") {
        return ["fa fa-file-powerpoint", true];
      }

      if (ext.toLowerCase() === "pdf") {
        return ["fa fa-file-pdf", true];
      }

      if (ext.toLowerCase() === "mp3") {
        return ["fa fa-file-audio", true];
      }

      if (ext.toLowerCase() === "mp4") {
        return ["fa fa-file-video", true];
      }

      if (
        ext.toLowerCase() === "jpg" ||
        ext.toLowerCase() === "png" ||
        ext.toLowerCase() === "PNG" ||
        ext.toLowerCase() === "jpeg" ||
        ext.toLowerCase() === "JPG" ||
        ext.toLowerCase() === "JPEG" ||
        ext.toLowerCase() === "gif" ||
        ext.toLowerCase() === "GIF"
      ) {
        return ["fa fa-file-image", true];
      }

      return ["fa fa-file-alt", true];
    },
    type(is_dir, ext) {
      if (is_dir) {
        return "Folder";
      } else {
        if (ext === "") {
          return "Unknown File";
        } else {
          if (
            ext == ".xls" ||
            ext == ".cvs" ||
            ext == ".csv" ||
            ext == ".xll" ||
            ext == ".xlsb" ||
            ext == ".xlam" ||
            ext == ".xlk" ||
            ext == ".xlsx" ||
            ext == ".xlsm" ||
            ext == ".xltm" ||
            ext == ".xltx"
          ) {
            return "Excel Document";
          }

          if (ext == ".doc" || ext == ".docx") {
            return "Word Document";
          }

          if (
            ext == ".mp3" ||
            ext == ".3pg" ||
            ext == ".aa" ||
            ext == ".aac" ||
            ext == ".aax" ||
            ext == ".act" ||
            ext == ".aiff" ||
            ext == ".amr" ||
            ext == ".ape" ||
            ext == ".au" ||
            ext == ".awb" ||
            ext == ".dct" ||
            ext == ".dss" ||
            ext == ".dvf" ||
            ext == ".flac" ||
            ext == ".gsm" ||
            ext == ".iklax" ||
            ext == ".ivs" ||
            ext == ".m4a" ||
            ext == ".m4b" ||
            ext == ".m4p" ||
            ext == ".mmf" ||
            ext == ".mpc" ||
            ext == ".msv" ||
            ext == ".nsf" ||
            ext == ".ogg" ||
            ext == ".oga" ||
            ext == ".mogg" ||
            ext == ".opus" ||
            ext == ".ra" ||
            ext == ".rm" ||
            ext == ".raw" ||
            ext == ".sln" ||
            ext == ".tta" ||
            ext == ".wav" ||
            ext == ".wma" ||
            ext == ".wv" ||
            ext == ".webm" ||
            ext == ".8svx"
          ) {
            return "Audio";
          }

          if (
            ext == ".mp4" ||
            ext == ".webm" ||
            ext == ".mkv" ||
            ext == ".flv" ||
            ext == ".vob" ||
            ext == ".ogv" ||
            ext == ".ogg" ||
            ext == ".drc" ||
            ext == ".gif" ||
            ext == ".gifv" ||
            ext == ".mng" ||
            ext == ".avi" ||
            ext == ".mov" ||
            ext == ".qt" ||
            ext == ".wmv" ||
            ext == ".yuv" ||
            ext == ".rm" ||
            ext == ".rmvb" ||
            ext == ".asf" ||
            ext == ".amv" ||
            ext == ".mp4" ||
            ext == ".m4p" ||
            ext == ".m4v" ||
            ext == ".mpg" ||
            ext == ".mp2" ||
            ext == ".mpeg" ||
            ext == ".mpe" ||
            ext == ".mpv" ||
            ext == ".mpg" ||
            ext == ".mpeg" ||
            ext == ".m2v" ||
            ext == ".m4v" ||
            ext == ".svi" ||
            ext == ".3gp" ||
            ext == ".3g2" ||
            ext == ".mxf" ||
            ext == ".roq" ||
            ext == ".nsv" ||
            ext == ".flv" ||
            ext == ".f4v" ||
            ext == ".f4p" ||
            ext == ".f4a" ||
            ext == ".f4b"
          ) {
            return "Video";
          }

          if (ext == ".jpg" || ext == ".png" || ext == ".gif") {
            return "Image File";
          }

          if (ext == ".txt") {
            return "Text Document";
          }
        }
      }
    },
    code(extname) {
      return (
        extname == ".xhtml" ||
        extname == ".html" ||
        extname == ".css" ||
        extname == ".java" ||
        extname == ".php" ||
        extname == ".js" ||
        extname == ".cs" ||
        extname == ".sql" ||
        extname == ".vue" ||
        extname == ".py" ||
        extname == ".cpp" ||
        extname == ".as" ||
        extname == ".h" ||
        extname == ".json" ||
        extname == ".rs" ||
        extname == ".r" ||
        extname == ".rb" ||
        extname == ".jsp"
      );
    },
    excel(extname) {
      return (
        extname == ".xls" ||
        extname == ".cvs" ||
        extname == ".csv" ||
        extname == ".xll" ||
        extname == ".xlsb" ||
        extname == ".xlam" ||
        extname == ".xlk" ||
        extname == ".xlsx" ||
        extname == ".xlsm" ||
        extname == ".xltm" ||
        extname == ".xltx"
      );
    },
    word(extname) {
      return extname == ".doc" || extname == ".docx";
    },
    audio(extname) {
      return (
        extname == ".mp3" ||
        extname == ".3pg" ||
        extname == ".aa" ||
        extname == ".aac" ||
        extname == ".aax" ||
        extname == ".act" ||
        extname == ".aiff" ||
        extname == ".amr" ||
        extname == ".ape" ||
        extname == ".au" ||
        extname == ".awb" ||
        extname == ".dct" ||
        extname == ".dss" ||
        extname == ".dvf" ||
        extname == ".flac" ||
        extname == ".gsm" ||
        extname == ".iklax" ||
        extname == ".ivs" ||
        extname == ".m4a" ||
        extname == ".m4b" ||
        extname == ".m4p" ||
        extname == ".mmf" ||
        extname == ".mpc" ||
        extname == ".msv" ||
        extname == ".nsf" ||
        extname == ".ogg" ||
        extname == ".oga" ||
        extname == ".mogg" ||
        extname == ".opus" ||
        extname == ".ra" ||
        extname == ".rm" ||
        extname == ".raw" ||
        extname == ".sln" ||
        extname == ".tta" ||
        extname == ".wav" ||
        extname == ".wma" ||
        extname == ".wv" ||
        extname == ".webm" ||
        extname == ".8svx"
      );
    },
    video(extname) {
      return (
        extname == ".mp4" ||
        extname == ".webm" ||
        extname == ".mkv" ||
        extname == ".flv" ||
        extname == ".vob" ||
        extname == ".ogv" ||
        extname == ".ogg" ||
        extname == ".drc" ||
        extname == ".gif" ||
        extname == ".gifv" ||
        extname == ".mng" ||
        extname == ".avi" ||
        extname == ".mov" ||
        extname == ".qt" ||
        extname == ".wmv" ||
        extname == ".yuv" ||
        extname == ".rm" ||
        extname == ".rmvb" ||
        extname == ".asf" ||
        extname == ".amv" ||
        extname == ".mp4" ||
        extname == ".m4p" ||
        extname == ".m4v" ||
        extname == ".mpg" ||
        extname == ".mp2" ||
        extname == ".mpeg" ||
        extname == ".mpe" ||
        extname == ".mpv" ||
        extname == ".mpg" ||
        extname == ".mpeg" ||
        extname == ".m2v" ||
        extname == ".m4v" ||
        extname == ".svi" ||
        extname == ".3gp" ||
        extname == ".3g2" ||
        extname == ".mxf" ||
        extname == ".roq" ||
        extname == ".nsv" ||
        extname == ".flv" ||
        extname == ".f4v" ||
        extname == ".f4p" ||
        extname == ".f4a" ||
        extname == ".f4b"
      );
    },
    getPhoto (photo) {
      const pt = `${this.backendUrl}/static-photos/${photo}`
      return pt
    },
    getInitials (name) {
      const nm = name.first
      return nm.charAt(0)
    },
    getUserName (name) {
      const nm = `${name.first} ${name.last}`
      return nm
    },
    str_text (is_dir, str, extname) {
      if (is_dir) {
        if (str != undefined) {
          if (str.length > 28) {
            return str.substr(0, 28) + '...'
          }

          return str
        }
      } else {
        if (str != undefined) {
          if (str.length > 28) {
            return str.substr(0, 28) + '...' + extname
          }

          return str + extname
        }
      }
    },
    format_date (val) {
      return moment(val).format('llll')
    }
  },
  mounted() {
    console.log(this.data)
  }
}
</script>
